import React, { useCallback, useEffect, useState, useRef } from "react";
import { useListFilters } from "../../helper/useListFilters";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import dayjs from "dayjs";
import CustomButton from "../../component/button/button";
import CustomDataTable from "../../component/datatable/DataTable";
import OutlineCustomButton from "../../component/button/outlineButton";
import Settinglist from "../../Icon/Settinglist";
import {
  GetOrganizationAction,
  GetUserAction,
  GetUserChatAction,
  GetUserChatByIdAction,
} from "../../Redux/action/SettingAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Message from "../../Icon/Message";
import Msg from "../../Icon/Msg";
import { type } from "@testing-library/user-event/dist/type";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ConfirmationModal from "../../component/Modal/ConfirmationModal/ConfirmationModal";
import DeleteWithDependencyModal from "../../component/Modal/DeleteWithDependencyModal";
import {
  DeleteOrganizationService,
  EditOrgBlockedStatusService,
} from "../../Redux/service/SettingService";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import {
  handleExport,
  handleExportOrg,
} from "../ExportFunction/ExportFunction";
import FilterComponent from "../../component/filterForTable/FilterComponent";
import { basicurl, token } from "../../Redux/ServiceUrl/url";
import axios from "axios";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CustomPagination } from "../../component/datatable/CustomPagination";
import { BulkUploadModal } from "../../component/Modal/BulkUploadModal";
import { DownloadOrgBulkUploadTemplateModal } from "../../component/Modal/DonwloadBulkUploadOrg";
import { toTitleCase } from "../../helper/helper";
import GlobalSearch from "../../component/sidebar/globalSearch";
import useRealtimeSync from "../../hooks/useRealtimeSync";
import { lastQuery } from "../../helper/lastQuery";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { sm: "100%", xs: "100%", md: "50%", lg: "50%" },
  height: "60vh",
  overflow: "scroll",
  bgcolor: "background.paper",
  border: "2px solid grey",
  boxShadow: 24,
  p: 4,
};
const UOrganizationlistPage = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [BulkModal, setBulkModal] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const [Organizationlist, setOrganizationlist] = useState([]);

  const [Chatlist, setChatlist] = useState([]);

  const [table_load, setTable_load] = useState(false);

  const [ChatByIdlist, setChatByIdlist] = useState([]);

  const [chatWindow, setChatWindow] = useState(false);

  const [chatId, setChatId] = useState("");

  const [Userlist, setUserlist] = useState([]);

  const [chatWithOwner, setChatWithOwner] = useState(false);

  const [OrganizationlistStateData, setOrganizationlistStateData] = useState(
    []
  );
  const [isToggled, setIsToggled] = useState(false);
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [confirmationopen, setConfirmationOpen] = useState(false);
  const [changeBlockStatusOfOrg, setChangeBlockStatusOfOrg] = useState({});
  // Organization queued for deletion: { id, name } or null
  const [orgToDelete, setOrgToDelete] = useState(null);
  const [selectionModel, setSelectionModel] = useState([]);
  const [data, setData] = useState([]);

  const [visibleColumns, setVisibleColumns] = useState([]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openbulk = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleBulkClose = () => {
    setAnchorEl(null);
  };

  const [loading, setLoading] = useState(true);

  const [uploadTemplateModal, setUploadTemplateModal] = useState(false);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 50,
    hasNextPage: false,
    hasPrevPage: false,
  });

  const handlePageChange = (page) => {
    setTable_load(true);
    console.log(page);
    let data = {
      page: page,
      limit: limit,
    };
    reload(data);
    // fetchData(page, pagination.limit);
  };

  const [limit, setLimit] = useState(50);

  const handleLimitChange = (newLimit) => {
    setTable_load(true);
    setLimit(newLimit);

    reload({ page: 1, limit: newLimit });
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Hide the loader after 2 seconds
    }, 2000); // Simulate 2 seconds of loading time
  }, []);

  const handleVisibleColumnsChange = useCallback((visibleColumns) => {
    // Handle the change in visible columns
    setVisibleColumns(visibleColumns);
  }, []);

  // Removed: this screen used to fetch every university, every program and
  // every role on mount with limit: 0. Nothing here (or in any child) reads
  // that state - the universities call alone was ~95MB of deeply populated
  // JSON, which is what made this page slow enough for the request to be cut
  // off. Add a targeted fetch back if a component on this screen ever needs it.

  const handleOpen = () => {
    // setOpen(true);
    navigate("/CAE/chatlist");
  };
  const handleClose = () => {
    setChatWithOwner(false);
    setOpen(false);
  };

  useEffect(() => {
    dispatch({ type: "GetOrganizationList", payload: null });
    setTable_load(true);
    let data = {
      page: 1,
      limit: 50,
    };
    reload(data);
  }, []);

  useEffect(() => {
    dispatch(GetUserChatAction());
  }, []);

  // Someone else (or another screen) added, updated or deleted an organization:
  // reload exactly the view the user is looking at. Local edits go through the
  // same path, so the table is never stale.
  useRealtimeSync(
    "organization",
    useCallback(() => {
      setTable_load(true);
      reload(lastQuery("organization", { page: 1, limit: 50 }));
    }, [dispatch])
  );

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 50,
      renderCell: (params) => {
        const handleEditActionClick = (event) => {
          event.stopPropagation();
          navigate(`/CAE/EditOrganization/${params.row.id}`);
        };
        return (
          <>
            <Tooltip title="Edit Organization">
              <IconButton onClick={handleEditActionClick}>
                <ModeEditIcon sx={{ fill: ThemeColor.LIGHTPURPLE }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },

    {
      field: "organizationName",
      headerName: "Organization Name",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div className="d-flex">
            {toTitleCase(params.row.organizationName)}
          </div>
        );
      },
    },
    {
      field: "state",
      headerName: "State",
      width: 150,
      renderCell: (params) => {
        return <div className="d-flex">{toTitleCase(params.row.state)}</div>;
      },
    },
    {
      field: "city",
      headerName: "City",
      width: 100,
      renderCell: (params) => {
        return <div className="d-flex">{toTitleCase(params.row.city)}</div>;
      },
    },
    {
      field: "country",
      headerName: "Country",
      width: 70,
      renderCell: (params) => {
        return <div className="d-flex">{toTitleCase(params.row.country)}</div>;
      },
    },
    {
      field: "owners.firstName",
      headerName: "Owner Name",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="d-flex">
            {params.row.owners?.map((owner, index) => {
              //(params.row.owners?.length);
              return (
                <div>
                  {toTitleCase(owner.firstName)}{" "}
                  {index + 1 === params.row.owners?.length ? "" : ", "}
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      field: "owners.phone",
      headerName: "Owner Contact Number ",
      width: 190,
      renderCell: (params) => {
        return (
          <div className="d-flex">
            {params.row.owners?.map((owner, index) => {
              //(params.row.owners?.length);
              return (
                <div>
                  {owner.phone}{" "}
                  {index + 1 === params.row.owners?.length ? "" : ", "}
                </div>
              );
            })}
          </div>
        );
      },
    },

    // {
    //   field: "additionalOrganizationName",
    //   headerName: "Organization Additional Name",
    //   width: 250,
    // },
    // {
    //   field: "id",
    //   headerName: "Organiztion Id",
    //   width: 250,
    // },
    // {
    //   field: "address",
    //   headerName: "Organiztion Address",
    //   width: 250,
    // },
    // {
    //   field: "start_date",
    //   headerName: "Start Date",
    //   width: 150,
    //   renderCell: (params) => {
    //     return (
    //       <div>
    //         {dayjs(params.row.startContractDate).format("YYYY-MM-DD HH:MM")}
    //       </div>
    //     );
    //   },
    // },
    {
      field: "end_date",
      headerName: "End Date",
      width: 150,
      renderCell: (params) => {
        return (
          <div>
            {params.row?.endContractDate
              ? dayjs(params.row.endContractDate).format("YYYY-MM-DD HH:MM")
              : "-"}
          </div>
        );
      },
    },
    {
      field: "isActive",
      headerName: "Status",
      width: 60,
    },
    {
      field: "blocked",
      headerName: "",
      width: 150,
      renderCell: (params) => {
        const handleBlockingActionClick = (event) => {
          event.stopPropagation();
          const newBlockedValue = params.row.isBlocked === "Y" ? "N" : "Y";
          setOrganizationlist((prev) =>
            prev.map((data) =>
              data.id === params.row.id ? { ...data, isBlocked: newBlockedValue } : data
            )
          );
          setChangeBlockStatusOfOrg({ id: params.row.id, isBlocked: newBlockedValue });
          setConfirmationOpen(true);
        };

        // show button only for admin or user (preserve original logic)
        if (
          !(
            window.sessionStorage.getItem("user_role_type") === "admin" ||
            window.sessionStorage.getItem("user_role_type") === "user"
          )
        )
          return null;

        const isBlocked = params.row.isBlocked === "Y";
        return (
          <Box display="flex" alignItems="center" className="px-2">
            <Button
              size="small"
              variant="contained"
              onClick={handleBlockingActionClick}
              sx={{
                backgroundColor: isBlocked ? "#28a745" : ThemeColor.RED,
                color: ThemeColor.WHITE,
                textTransform: "none",
                minWidth: 90,
                '&:hover': {
                  backgroundColor: isBlocked ? '#229a3f' : '#c92b27',
                },
              }}
            >
              {isBlocked ? "Unblock" : "Block"}
            </Button>
          </Box>
        );
      },
    },
    // Delete sits last, after the Block button.
    {
      field: "delete",
      headerName: "",
      width: 80,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        // Deleting cascades agents and folders, so keep it to admins.
        if (window.sessionStorage.getItem("user_role_type") !== "admin") {
          return null;
        }

        const handleDeleteActionClick = (event) => {
          event.stopPropagation();
          setOrgToDelete({
            id: params.row.id,
            name: params.row.organizationName,
          });
        };

        return (
          <Tooltip title="Delete Organization">
            <IconButton onClick={handleDeleteActionClick}>
              <DeleteOutlineIcon sx={{ fill: ThemeColor.RED }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const OrganizationlistState = useSelector(
    (state) => state.setting?.organization?.data
  );
  const ChatlistState = useSelector(
    (state) => state.setting?.allchat?.data?.data
  );
  useEffect(() => {
    // console.log(UniversitylistState?.pagination)
    if (OrganizationlistState) {
      // const { data, pagination } = OrganizationlistState;
      // setRows(data);
      setPagination(OrganizationlistState?.pagination);
    }
  }, [OrganizationlistState]);

  useEffect(() => {
    // Rows for a filtered view do not come from redux. Letting this run
    // would write the stale unfiltered list back over them - which is why
    // the filter survived a reload (redux is empty then) but not a Back.
    //
    // A later redux change means an action elsewhere refreshed the data
    // (a modal, an import), so the filtered view is fetched again instead.
    if (getFilters().length > 0) {
      if (reduxSyncedOnce.current) fetchData(getFilters());
      reduxSyncedOnce.current = true;
      return;
    }
    reduxSyncedOnce.current = true;
    // setOrganizationlistStateData(OrganizationlistState?.organizations);
    if (!isToggled) {
      setOrganizationlist(
        OrganizationlistState?.organizations?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    } else {
      setOrganizationlist(
        OrganizationlistState?.BloackedOrganisations?.map(
          ({ _id, ...rest }) => ({
            id: _id,
            ...rest,
          })
        )
      );
    }

    if (OrganizationlistState != undefined) setTable_load(false);
  }, [OrganizationlistState]);

  useEffect(() => {
    setChatlist(ChatlistState);
  }, [ChatlistState]);

  const getChat = (id) => {
    //(id);
    setChatId(id);
    setChatWindow(true);
    dispatch(GetUserChatByIdAction(id));
  };
  const ChatByIdlistState = useSelector(
    (state) => state.setting?.chat?.data?.data
  );

  useEffect(() => {
    setChatByIdlist(ChatByIdlistState);
  }, [ChatByIdlistState]);

  function generate(array) {
    return array?.map((value) => {
      return (
        <ListItem>
          <ListItemButton
            onClick={() => {
              getChat(value._id);
            }}
          >
            <ListItemIcon>
              <Message />
            </ListItemIcon>
            <ListItemText primary={value.title} />
          </ListItemButton>
        </ListItem>
      );
    });
  }

  const UserlistState = useSelector(
    (state) => state.setting?.user?.data?.activeUsers
  );

  //("user list", UserlistState);

  useEffect(() => {
    setTable_load(true);
    dispatch(GetUserAction());
  }, []);

  useEffect(() => {
    const updatedData = UserlistState?.map(({ firstName, ...rest }) => ({
      title: firstName,
      ...rest,
    }));
    setUserlist(updatedData);
    setTable_load(false);
  }, [UserlistState]);

  // Handle toggle change
  const handleStatusChange = async () => {
    const newToggleState = !isToggled;
    if (newToggleState) {
      setOrganizationlist(
        OrganizationlistState?.BloackedOrganisations?.map(
          ({ _id, ...rest }) => ({
            id: _id,
            ...rest,
          })
        )
      );
    } else {
      setOrganizationlist(
        OrganizationlistState?.organizations?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    }
    setIsToggled(newToggleState);
  };

  const fields = [
    {
      label: "Organization",
      value: "organizationName",
      type: "text",
      option: OrganizationlistStateData?.map(
        ({ organizationName, ...rest }) => ({
          title: organizationName,
          ...rest,
        })
      ),
    },
    {
      label: "Additional Organization Name",
      value: "additionalOrganizationName",
      type: "text",
      option: OrganizationlistStateData?.map(
        ({ additionalOrganizationName, ...rest }) => ({
          title: additionalOrganizationName,
          ...rest,
        })
      ),
    },
    {
      label: "Is Active",
      value: "isActive",
      type: "multi-select",
      option: [
        { _id: "Y", title: "Yes" },
        { _id: "N", title: "No" },
      ],
    },
  ];
  const fetchData = async (filters) => {
    let string = filters.map((data) => `${data.field}=${data.value}`);
    try {
      let response = await axios.get(
        basicurl +
        `/api/organization/get-all-organizations?${string.join("&")}&limit=${0}&page=${1}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // const result = await response.json();
      console.log(response);
      setPagination(response.data?.pagination)
      if (isToggled) {
        setOrganizationlist(
          response.data?.BloackedOrganisations?.map(({ _id, ...rest }) => ({
            id: _id,
            ...rest,
          }))
        );
      } else {
        setOrganizationlist(
          response.data?.organizations?.map(({ _id, ...rest }) => ({
            id: _id,
            ...rest,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  };

  /**
   * Reload the rows.
   *
   * Every action on this page reloads through here so that a filter which
   * is on screen stays applied. Applying a filter used `fetchData` while
   * every action afterwards used the plain redux action, so the table went
   * back to showing everything while the panel still said a filter was on.
   *
   * The filters live in component state, so leaving the page and coming
   * back starts clean with the full list.
   */
  /** False until the first redux sync, so mounting does not fetch twice. */
  const reduxSyncedOnce = useRef(false);

  const { activeFilters, getFilters, applyFilters } = useListFilters(
    (filters) => fetchData(filters),
    () => dispatch(GetOrganizationAction({ page: 1, limit: limit }))
  );

  const reload = (data) => {
    // Read through the ref: some of the callers below are memoised with
    // empty deps, so a captured value would be frozen as "no filters".
    const applied = getFilters();
    if (applied.length > 0) {
      fetchData(applied);
      return;
    }
    dispatch(GetOrganizationAction(data));
  };

  const handleApplyFilters = applyFilters;

  const handleGetBulkTemplate = async () => {
    try {
      const response = await axios.get(
        `${basicurl}/api/organization/download-organization-template`,
        {
          responseType: "blob", // 👈 VERY important for binary data like Excel
        }
      );

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a download link and click it
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "organization_bulk.xlsx"; // 👈 you can set a dynamic filename
      document.body.appendChild(a);
      a.click();
      a.remove();

      // Clean up the blob URL
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            fontSize: "24px",
            color: "#007bff",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "transparent",
            }}
          >
            <div style={{ width: "100%", height: "100%", justifyContent: "center", display: "flex", alignItems: "center" }}>
              <img
                src="/assest/Group.png" // Your image URL
                alt="Loading..."
                style={{ width: "75%", height: "75%", objectFit: "contain" }}
              />
            </div>

            <CircularProgress
              size={100}
              sx={{
                color: ThemeColor.NAVYBLUE, // Customize the loader color
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
              }}
            />
          </div>
        </div>
      ) : (
        <>
          <Grid container spacing={2} alignItems="center">
            <Grid item lg={3} md={3} xs={12}>
              <div className="d-flex align-items-center">
                <IconButton onClick={() => navigate(-1)}>
                  <ArrowBackIcon />
                </IconButton>
                <Typography
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h2.small}
                >
                  Organization List
                </Typography>
              </div>
            </Grid>
            <Grid item lg={9} md={9} xs={12}>
              <Box
                className="d-flex align-items-center w-100"
                sx={{
                  justifyContent: {
                    xs: "flex-start",
                    sm: "flex-start",
                    md: "flex-end",
                  },
                  flexWrap: "wrap",
                  gap: 1.5,
                }}
              >
                <OutlineCustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  onClick={() => setFilterOpen(true)}
                >
                  Filter
                </OutlineCustomButton>
                <OutlineCustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  onClick={() =>
                    handleExportOrg(
                      selectionModel,
                      "Organization",
                      Organizationlist,
                      "isActive",
                      visibleColumns,
                      columns
                    )
                  }
                >
                  Export
                </OutlineCustomButton>

                <Box
                  display="flex"
                  sx={{
                    border: `2px solid ${ThemeColor.GREY}`,
                    borderRadius: 25,
                    px: 2,
                    py: 0.5,
                  }}
                  alignItems="center"
                >
                  <Typography>Blocked</Typography>
                  <Switch
                    sx={{
                      "& .MuiSwitch-track": {
                        transition: "background-color 0.3s",
                        borderRadius: 20,
                      },
                      "& .MuiSwitch-thumb": {
                        width: 24,
                        height: 24,
                        backgroundColor: isToggled
                          ? ThemeColor.PURPLE
                          : ThemeColor.BLACK,
                        transition: "transform 0.3s ease",
                        transform: isToggled
                          ? "translateX(2px)"
                          : "translateX(0px)",
                      },
                      "& .MuiSwitch-switchBase": {
                        padding: 1,
                        transition: "transform 0.3s",
                        "&.Mui-checked + .MuiSwitch-track": {
                          backgroundColor: ThemeColor.LIGHTPURPLE,
                        },
                      },
                    }}
                    checked={isToggled ? true : false}
                    onChange={handleStatusChange}
                    color="primary"
                  />
                </Box>
                <CustomButton
                  variant="contained"
                  type="submit"
                  color={ThemeColor.YELLOW}
                  onClick={handleClick}
                >
                  Bulk Update
                </CustomButton>
                <Menu
                  id="demo-positioned-menu"
                  aria-labelledby="demo-positioned-button"
                  anchorEl={anchorEl}
                  open={openbulk}
                  onClose={handleBulkClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <MenuItem
                    onClick={() =>
                      setUploadTemplateModal(!uploadTemplateModal)
                    }
                  >
                    Download Template
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setBulkModal(!BulkModal);
                    }}
                  >
                    Upload Data (Bulk)
                  </MenuItem>
                </Menu>
                {(window.sessionStorage.getItem("user_role_type") === "admin" ||
                  !window.sessionStorage.getItem("user_role_type") === "user") && (
                  <CustomButton
                    variant="contained"
                    type="submit"
                    color={ThemeColor.WHITE}
                    onClick={() => navigate("/CAE/CreateOrganization")}
                  >
                    Add &nbsp;Organization
                  </CustomButton>
                )}
              </Box>
            </Grid>
          </Grid>
          <div className="table-container mt-4" style={{ overflowX: "hidden" }}>
            <CustomDataTable
              row={Organizationlist ? Organizationlist : []}
              columns={columns}
              loading={table_load}
              onSelectionChange={(newSelection) => {
                setSelectionModel(newSelection);
              }}
              getRowClassName={(params) =>
                params.row.isBlocked === "Y"
                  ? "row-yellow"
                  : params.row.isActive === "Y"
                    ? "row-white"
                    : "row-dull"
              }
              onVisibleColumnsChange={handleVisibleColumnsChange}
              minTableWidth="100%"
            />
          </div>
          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            limit={limit}
            onLimitChange={handleLimitChange}
          />
          <BulkUploadModal
            open={BulkModal}
            handleClose={() => {
              setBulkModal(!BulkModal);
            }}
            url={"api/organization/bulk-upload-organizations"}
            action={() => {
              let data = {
                limit: limit,
                page: 1,
              };
              reload(data);
            }}
          />
          <FilterComponent
            open={isFilterOpen}
            onClose={() => setFilterOpen(false)}
            onApply={handleApplyFilters}
            initialFilters={activeFilters}
            fields={fields}
          />
          <ConfirmationModal
            msg="Updated"
            btnName="Update"
            handleConfirmationClose={() => {
              setOrganizationlist((prev) =>
                prev.map((data) =>
                  data.id === changeBlockStatusOfOrg.id
                    ? {
                      ...data,
                      isBlocked:
                        changeBlockStatusOfOrg.isBlocked === "Y" ? "N" : "Y",
                    }
                    : data
                )
              );
              setConfirmationOpen(false);
            }}
            deletefunction={async () => {
              try {
                const res = await EditOrgBlockedStatusService(
                  changeBlockStatusOfOrg
                );

                if (res.status === 200) {
                  let data = {
                    page: 1,
                    limit: 50,
                  };
                  reload(data);
                  // setIsToggled(!isToggled);
                  // handleStatusChange(); // Dispatch the action if success
                  return res; // Return the result so the child can access it
                } else {
                  return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={confirmationopen}
            message={"Want to change the blocking status?"}
          />

          <DeleteWithDependencyModal
            open={Boolean(orgToDelete)}
            onClose={() => setOrgToDelete(null)}
            entityLabel="Organization"
            entityName={orgToDelete?.name || ""}
            cascadeItems={[
              "All agents / users belonging to this organization",
              "Its folder, sub-folders and every file inside them",
              "Its reminders and activity history",
            ]}
            onDelete={() => DeleteOrganizationService(orgToDelete.id)}
            onDeleted={() => {
              dispatch(showSnackbar("Organization deleted", "success"));
              reload({ page: 1, limit: limit });
            }}
          />

          <DownloadOrgBulkUploadTemplateModal
            open={uploadTemplateModal}
            handleClose={() => {
              setUploadTemplateModal(!uploadTemplateModal);
            }}
          />
        </>
      )}
    </div>
  );
};

function UOrganizationlist() {
  const dispatch = useDispatch();

  const handleSearch = (searchValue) => {
    console.log(searchValue);
    let data = {
      page: 1,
      limit: 50,
      search: searchValue,
    };

    dispatch(GetOrganizationAction(data));
  };
  return (
    <div>
      <ResponsiveDrawer
        maincontent={<UOrganizationlistPage />}
        globalsearch={<GlobalSearch onSearch={handleSearch} />}
      />
    </div>
  );
}

export default UOrganizationlist;
